import React from "react";
import { useEffect } from "react";
import { Link } from "react-router-dom";
import LazyLoad from "react-lazyload";
import NKRHeader from "../Component/NKRHeader";
import NKRFooter from "../Component/NKRFooter";
const Vision = () => {
  useEffect(() => {
    document.title = "Vision -  Gayatri International School";
  }, []);
  return (
    <>
      <NKRHeader />
      <section className="page-header-fb innerslide">
        <div className="innerslide">
          <LazyLoad>
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GISFNU/public/Images/innerslide1.gif"
              className="img-fluid"
            />
          </LazyLoad>{" "}
        </div>
        <div className="page-header__inner">
          <h2>Vision</h2>
          <ul className="thm-breadcrumb list-unstyled ml-0">
            <li>
              <Link to="/Nekhpur/Home">Home</Link>
            </li>
            <li>|</li>
            <li>The School</li>
            <li>|</li>
            <li>Vision </li>
          </ul>
        </div>
      </section>
      <section className="innerbody">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <p>
                GIS aims to mentor each child to be an achiever in life. We
                equip gayatrians with the invincible mantra of strength, vision
                and wisdom, the three powerful virtues of a truly educated
                person.
              </p>
              <p>
                Strength carves the path and promises to carry the young
                learners to their destination.
              </p>
              <p>
                Vision is the capacity to see the visible and the invisible
                truth it also guides a learner to design the path through which
                strength would tread. Right outlook will enable gayatrians to be
                confident of what they are and put efforts to be what they could
                be.
              </p>
              <p>
                Wisdom gives a deep insight into the truths of the world. It
                makes one realise the immortality of being our children learn to
                be fearless .{" "}
              </p>
            </div>
          </div>
        </div>
      </section>
      <NKRFooter />
    </>
  );
};

export default Vision;
